var _rect, _rect2, _polygon, _polygon2, _polygon3, _rect3, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComingsoonImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Birds--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.2,220.4s-.31-3.56-1.15-4.12a47.32,47.32,0,0,0-6-1.9s2,5.48,3.25,6.11S108.2,220.4,108.2,220.4Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1,214.38h0c.06.17,2,5.49,3.25,6.11a4.63,4.63,0,0,0,2.53.17,10,10,0,0,0,1.32-.27s-.32-3.55-1.15-4.11a43.76,43.76,0,0,0-5.92-1.89h0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1,214.38c.06.17,2,5.49,3.25,6.11a4.63,4.63,0,0,0,2.53.17c1.17-.78-1.31-1.64-1.67-1.92s-.14-.55,0-.75-.32-.67-.84-.87a.92.92,0,0,1-.55-1.19c.11-.56-2.36-1.43-2.67-1.54h0Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.81,218.26c-1.16,0-3.8,1.27-4.67,1.33s-5.2-2.92-6.13-3.41-9.09-1.59-9.09-1.59,5.42,5.54,9.09,5.7a12.82,12.82,0,0,1-3.51.56,35.76,35.76,0,0,0-7.65-.75l5,1.64-4.39.56a22.44,22.44,0,0,0,6.2.24,31.4,31.4,0,0,0,4.85,1.34,7.67,7.67,0,0,0,6.63-1.36c1.59-1.28,6.83-2.73,6.83-2.73l-1.79-.64A1.58,1.58,0,0,0,110.81,218.26Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.88,221.74l-4.39.57a22.79,22.79,0,0,0,6.2.23,29,29,0,0,0,3.9,1.13l1,.21a7.67,7.67,0,0,0,6.63-1.36,13.11,13.11,0,0,1,3.14-1.53l.59-.22h0c.14-.05.29-.11.44-.15.33-.12.65-.22.94-.31,1-.32,1.71-.52,1.71-.52l-1.79-.64a1.58,1.58,0,0,0-1.4-.89,12.6,12.6,0,0,0-3.28.93,6.47,6.47,0,0,1-1.39.4c-.87.07-5.2-2.92-6.13-3.41a29.14,29.14,0,0,0-4.67-.94c-2.23-.36-4.42-.65-4.42-.65s3.75,3.84,7.13,5.22a6.72,6.72,0,0,0,1.75.47H100a12.25,12.25,0,0,1-3.47.55,15.58,15.58,0,0,0-1.78-.35h0a41.59,41.59,0,0,0-5.87-.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.53,219.19a2.55,2.55,0,0,1,1.56.35c.34.37.66,1.15,1.22,1.45l.59-.22h0c.14-.05.29-.11.44-.15.33-.12.65-.22.94-.31a3.82,3.82,0,0,0-.08-1.16,1.58,1.58,0,0,0-1.4-.89A12.6,12.6,0,0,0,107.53,219.19Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.92,214.59s3.75,3.84,7.13,5.22a12.58,12.58,0,0,0,1.75.47h0l.17,0c2.73.43,3,0,3,0s-.93-.27-1-.27.39-.3-.21-.52-.5-.52-.5-.52a8.13,8.13,0,0,1-1.7-.74c-.06-.18.21-.48-.53-.63s0-.53-1.19-.95S97,216,97,216a3.15,3.15,0,0,1-1.66-.78C93.11,214.88,90.92,214.59,90.92,214.59Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.88,221.74l-4.39.57a22.79,22.79,0,0,0,6.2.23,29,29,0,0,0,3.9,1.13c.51-.27-.92-.72-1.55-1-.8-.42-.68-.32-.38-.53s0-.27-1-.48-.71-.42-1.27-.85a2.33,2.33,0,0,0-.71-.27h0a41.59,41.59,0,0,0-5.87-.39Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.21 219.15 111.7 219.51 112.01 220.4 114 219.79 112.21 219.15",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.57,93.82c-2.12-1.32-10.8,8-14.92,9.22a14.53,14.53,0,0,0,9,.12C358.23,101.57,361.8,95.21,359.57,93.82Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.65,103a14.53,14.53,0,0,0,9,.12c4.54-1.59,8.12-8,5.88-9.34-.5-.31-1.37,0-2.46.61C353.6,96.47,347.79,102.14,344.65,103Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.65,103s3.71.4,4.22-.16a2.55,2.55,0,0,1,2.08-.81c1,0,1.44-.52,1.26-1.56s1.29-.49,2.17-.84-.1-.66-.12-1.39,1.75-.81,1.86-1.4-.6-.45-.22-1.06,1.67-.82,1.21-1.39C353.6,96.47,347.79,102.14,344.65,103Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.42,92c-2.13-.47-7.44,1-9.07.82-1.46-.16-11.53-.84-11.53-.84s-5.27.45-6.66-.2c-5.53-2.58-13.83-4-13.83-4l8.7,4.77-8.27-.48s3.56,1.63,11.33,2.59a58.2,58.2,0,0,0,8.47,4.16c6.47,2.7,11.14.63,12.68-.19,3.36-1.81,13.51-2.67,13.51-2.67l-3.06-1.79A2.94,2.94,0,0,0,366.42,92Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,92.53,325.75,92s3.57,1.64,11.34,2.6c0,0,.13.09.41.25a61.54,61.54,0,0,0,6.38,3.18c.52.24,1.08.47,1.67.72a16.49,16.49,0,0,0,6.49,1.35,13.43,13.43,0,0,0,6.19-1.54,24.36,24.36,0,0,1,6.31-1.74l1.17-.19h0l.86-.13,1.84-.24c1.93-.24,3.33-.36,3.33-.36l-3.06-1.8A3,3,0,0,0,366.42,92c-1.4-.3-4.17.22-6.36.57a12.56,12.56,0,0,1-2.71.26c-1.63-.18-11.66-.87-11.53-.84h-.08c-.67,0-5.3.39-6.58-.21-1-.45-2.05-.88-3.14-1.26h0a77.52,77.52,0,0,0-10.67-2.76Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.06,92.59c1,.2,2.36.57,2.74,1.18.51.8.82,2.35,1.75,3.1.39-.07.78-.14,1.16-.19h0l.87-.13c.64-.1,1.27-.18,1.84-.25a7.16,7.16,0,0,0,.26-2.16A2.93,2.93,0,0,0,366.42,92C365,91.71,362.25,92.24,360.06,92.59Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,92.53l-8.26-.48s3.56,1.63,11.33,2.59a52.6,52.6,0,0,0,6.79,3.44c1-.32-1.46-1.64-2.49-2.45-1.34-1-1.15-.85-.53-1.12s0-.51-1.59-1.22-1.16-1-2.06-2a4.38,4.38,0,0,0-1.19-.75h0a76.71,76.71,0,0,0-10.67-2.77Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.69 94.14 367.63 94.64 367.88 96.37 371.75 95.94 368.69 94.14",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.5,94.89a61.54,61.54,0,0,0,6.38,3.18c.52.24,1.08.47,1.67.72a16.49,16.49,0,0,0,6.49,1.35,16.11,16.11,0,0,0,3-4.21s-.59-1.78-3.69-2.89C349.27,92.32,342.15,93.79,337.5,94.89Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.94,92.92c-3.87-2-26,6.81-35.08,7.22a51.63,51.63,0,0,0,18.86,2.25C348.88,101.6,359,95.05,354.94,92.92Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.86,100.14a51.63,51.63,0,0,0,18.86,2.25c10.15-.79,20.31-7.34,16.22-9.47-.91-.48-2.85-.35-5.39.13C341.35,94.6,326.81,99.83,319.86,100.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.86,100.14s7.59,1.33,8.9.8a9.15,9.15,0,0,1,4.69-.46c2.17.2,3.23-.27,3.29-1.52s2.9-.26,4.88-.46.07-.79.33-1.64,4-.54,4.48-1.2-1.05-.66,0-1.27,3.83-.57,3.12-1.34C341.35,94.6,326.81,99.83,319.86,100.14Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--water-2--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.31,399.11H472s-1.78-3.94-19.58-2c-8.26.91-10.48-1.68-15.63-2.72s-8.7,3-17,2.35-9.49-7-15.82-7.74c-7.35-.85-5.94,4.91-12.66,5.62s-8.11-4.88-14.64-4.88c-6.9,0-10.91,8.29-24.84,4.57S330.31,399.11,330.31,399.11Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.31,399.11H472s-1.78-3.94-19.58-2c-8.26.91-10.48-1.68-15.63-2.72s-8.7,3-17,2.35-9.49-7-15.82-7.74c-7.35-.85-5.94,4.91-12.66,5.62s-8.11-4.88-14.64-4.88c-6.9,0-10.91,8.29-24.84,4.57S330.31,399.11,330.31,399.11Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8,399.11H166.5s-1.78-3.94-19.58-2c-8.26.91-10.48-1.68-15.62-2.72s-8.71,3-17,2.35-9.49-7-15.82-7.74c-7.34-.85-5.93,4.91-12.66,5.62s-8.11-4.88-14.64-4.88c-6.89,0-10.91,8.29-24.84,4.57S24.8,399.11,24.8,399.11Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8,399.11H166.5s-1.78-3.94-19.58-2c-8.26.91-10.48-1.68-15.62-2.72s-8.71,3-17,2.35-9.49-7-15.82-7.74c-7.34-.85-5.93,4.91-12.66,5.62s-8.11-4.88-14.64-4.88c-6.89,0-10.91,8.29-24.84,4.57S24.8,399.11,24.8,399.11Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.76,268.45,251.41,280.9c27-72.13-19.57-141.57-19.57-141.57,72.12,8.3,127.7-9.4,128.72-9.72h0C409.66,175.2,376.76,268.45,376.76,268.45Z",
    style: {
      fill: "#FFA47A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.87,266.85s12.31-73-10.11-124.16c0,0,17.25,68.39-6.65,115.46-29.52-9.07-66.41,4.67-66.41,4.67,23.2-4.63,47.15,1.31,48.23,1.58-39-5.48-81.36,11.48-81.92,11.7.46-.57,16.25-20.57,13.52-59.69s-31.14-68.56-32-69.47c30.86,20.17,72.69,11.6,72.69,11.6-36.75,5.23-69.8-15.27-70.71-15.84,1,.36,42.73,14.8,76.33,7.3s42.48-20,42.75-20.39c-1,.32-56.6,18-128.72,9.72,0,0,46.53,69.44,19.57,141.57l125.35-12.45c-.62-.56-1.25-1.08-1.89-1.6Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 226.39,
    y: 131.89,
    width: 134.28,
    height: 3.45,
    transform: "translate(-10.34 25.56) rotate(-4.9)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 245.05,
    y: 272.23,
    width: 134.28,
    height: 3.45,
    transform: "translate(-22.26 27.66) rotate(-4.9)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 226.39,
    y: 131.89,
    width: 134.28,
    height: 3.45,
    transform: "translate(-10.34 25.56) rotate(-4.9)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.05,
    y: 272.23,
    width: 134.28,
    height: 3.45,
    transform: "translate(-22.26 27.66) rotate(-4.9)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.35,208.36l11.16-.52s.05-1.88,1.11-2.59,9.62-1.8,9.62-1.8,1.32,5.7,0,7.42-8.44,2.9-9.1,2.5a6.68,6.68,0,0,1-1.38-1.32l-9.56,1.4Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.33,188.2c11.33,1.83,22.21,11.33,26.56,14.69s18.72,4.63,18.72,4.63v7.24s-9.42,4.94-20.3,3.76-28.09-16.88-28.09-16.88Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.61,207.52v7.24s-9.42,4.94-20.3,3.76c-5.67-.62-13.06-5.18-18.84-9.4-5.31-3.88-9.25-7.48-9.25-7.48l1.14-4.95,2-8.49c11.34,1.83,22.22,11.33,26.57,14.69S273.61,207.52,273.61,207.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.1 206.36 272.1 216.41 274.74 215.45 274.74 206.36 272.1 206.36",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.1 206.36 272.1 216.41 274.74 215.45 274.74 206.36 272.1 206.36",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.47,209.12c-5.31-3.88-9.25-7.48-9.25-7.48l1.14-4.95a5.69,5.69,0,0,1,1.74.47S235,202.22,234.47,209.12Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.88,151.26v-7.85s-2.42-1.67-2.13-2.17-.33-7.84,0-9,6.77-4,7-3.68,1.52,10.16,1.19,11.34-2.34,2.52-2.34,2.52l-.16,9.85Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.3,182.13c-8.77-3.57-22.88-22.16-23.83-33.64l-6.9,2.77s-4.55,24,3.17,33.48,25.15,11.64,25.15,11.64Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.3,182.13l-1.66,9.79-.75,4.46A59,59,0,0,1,172,192.52c-4.15-1.77-8.35-4.28-11.21-7.78-7.72-9.44-3.17-33.48-3.17-33.48l6.89-2.77C165.42,160,179.53,178.56,188.3,182.13Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.64,191.92l-.75,4.46A59,59,0,0,1,172,192.52C176.91,191.48,183.58,191.73,186.64,191.92Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.45,230.13H179.63c-3.59,19.64-14.85,99.37-6.77,161.28h12.8s-1.18-94,10.12-124.41c1.3,16.26,14.52,124.34,14.52,124.34h13s-2-40.66-3.9-79.06C218.2,288.1,217.5,235.1,217.45,230.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.78,267a101.21,101.21,0,0,0-4.23,16.36c-1.05-14.47,3.18-29.81,3.18-29.81Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.86,390.58h8.66a.62.62,0,0,1,.6.49l1.41,6.35a1,1,0,0,1-.81,1.24l-.23,0c-2.8-.05-4.84-.22-8.36-.22-2.17,0-8.7.23-11.69.23s-3.38-3-2.16-3.23c5.49-1.2,9.63-2.86,11.39-4.43A1.74,1.74,0,0,1,212.86,390.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.15,390.36h8.66a.63.63,0,0,1,.61.49l1.4,6.34a1.05,1.05,0,0,1-.81,1.25l-.23,0c-2.8,0-4.84-.22-8.36-.22-2.16,0-8.7.23-11.69.23s-3.38-3-2.16-3.23c5.5-1.19,9.63-2.85,11.39-4.43A1.69,1.69,0,0,1,176.15,390.36Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "184.53 234.72 178.83 234.65 179.32 230.59 184.53 230.59 184.53 234.72"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "205.15 230.59 217.38 230.59 217.38 235.12 205.15 234.97 205.15 230.59"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "203.79 234.95 185.89 234.74 185.89 230.59 203.79 230.59 203.79 234.95"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 189.63,
    y: 229.79,
    width: 7.04,
    height: 5.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.38,230.59H179.32s-.49-27.17,9-48.46l40,6.07a2.75,2.75,0,0,1,2.07,3.91C227.28,198.67,220.56,214,217.38,230.59Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.38,230.59H179.32s-.49-27.17,9-48.46l40,6.07a2.75,2.75,0,0,1,2.07,3.91C227.28,198.67,220.56,214,217.38,230.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.87,201.64s12.29-6.39,16-10.42h7.3s-4.14-8.23-13.15-10.05-13.69,2.21-16.29,0c0,0-.1,4.31,2.7,6.09A23.72,23.72,0,0,0,201.87,201.64Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.87,201.64s12.29-6.39,16-10.42h7.3s-4.14-8.23-13.15-10.05-13.69,2.21-16.29,0c0,0-.1,4.31,2.7,6.09A23.72,23.72,0,0,0,201.87,201.64Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.06,184.74s-3.09,3.31-1.24,15.58c0,0,12.54-7.86,14.51-13.42Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,188.27s8,1.45,11.36-1.37c-1.54-1.84-1.79-5-1.47-8.31a43.32,43.32,0,0,1,1.32-6.92c.2-.73.4-1.41.6-2l-10.22,6.88.06.48c0,.47.09.94.1,1.41a8.73,8.73,0,0,1-.44,3.35,7.48,7.48,0,0,1-.85,2.13,3.53,3.53,0,0,1-2.37.84C201.94,186.26,205,188.27,205,188.27Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.43,183.9a16,16,0,0,0,9.43-5.31,43.32,43.32,0,0,1,1.32-6.92L206.62,177c0,.47.09.94.1,1.41a8.73,8.73,0,0,1-.44,3.35A7.48,7.48,0,0,1,205.43,183.9Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.19,175.77c3.5-.37,5.4-1,4.82-3.35s-.13-1,2.38-3.75,2.77-2.47,1.45-5.39-.79-5.64-.14-8,.57-3.45-2.22-4.64-4.91-1.45-4.7-4.68-4-2.7-6-2a2.17,2.17,0,0,1-2.77-1.19s-.82.79.76,1.85,1.7,2.11,1.7,2.11a18.28,18.28,0,0,0-4.37-1.45c-1.55-.13-6,2.11-7.65.72s-4.18,0-4.18,0,2.37-.46,2.9,0,1,2.44,2.53,1.92c0,0-3.06,2.76-5.43,1.71s-2.11,1.35-4.09,2.52-2.24.12-3-.81-2.38,0-2.38,0,1.44-.36,1.84.81,2.38,4.25,3.7,3.17,1.85,1.3,1.85,1.3-1.45-.66-2.24.26-2.79,1.85-3.31,1.06-.52,3.49,1.06,3.19,2.25,2.25,2.77,2.23,2.25,0,2.25,0-.14,2.41-1.85,2.18a2.7,2.7,0,0,0-2.57,1.31s1.65-.72,2.31,0,3.48,4.58,5.17,3.37a19.18,19.18,0,0,0,8.14,5.63C209.33,177.77,215.19,175.77,215.19,175.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.19,153.19s-2.89,9.36,1.65,13.8,7.2-13.38,7.2-13.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.46,176.81A8.79,8.79,0,0,1,204,178.69a9.76,9.76,0,0,1-4.85-5.33,8,8,0,0,1-.32-1c-1.63-6.23-.9-16.59,5.87-19.5A9.52,9.52,0,0,1,218,162.13C217.74,169.09,217.91,173.19,214.46,176.81Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.48,164.29c.05.57-.28,1-.65,1s-.68-.45-.7-1,.29-1,.65-1S207.46,163.72,207.48,164.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.07,164.43c.05.56-.28,1-.65,1s-.68-.45-.69-1,.28-1,.65-1S201.06,163.89,201.07,164.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.11,164.66a20.27,20.27,0,0,1-2.6,4.91,3.26,3.26,0,0,0,2.73.45Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.68,161.84a.35.35,0,0,0,.34,0,2.69,2.69,0,0,1,2.35-.5.34.34,0,0,0,.43-.2.33.33,0,0,0-.2-.42h0a3.3,3.3,0,0,0-3,.59.32.32,0,0,0-.07.46h0A.41.41,0,0,0,198.68,161.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.69,161.72a.31.31,0,0,0,.18-.07.33.33,0,0,0,0-.46h0a3.27,3.27,0,0,0-3-.72.32.32,0,0,0-.22.41h0a.34.34,0,0,0,.41.22h0a2.67,2.67,0,0,1,2.33.61A.33.33,0,0,0,208.69,161.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.71,153.55l-.64,1.31c2.28.81,1.76,3.46,1.26,4.66-1.06,2.55.3,6.59,2.23,8.24,0,0,.09-1.11,1-.82s.52,6.1-1.4,8.83c0,0,2.85-2.44,4.59-8.51,1.61-5.61,1.91-10.31.81-12.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.16,167.77a6.62,6.62,0,0,1-3.73,3.43c-2.18.78-3.44-1.13-3-3.29.43-1.91,2.07-4.68,4.34-4.51A3,3,0,0,1,221.16,167.77Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.17,165.31l-.82-.65s0,3.75-1.29,4.61c0,0-4.1-.16-5.57,0A4.33,4.33,0,0,0,205,171s-3.06-1.14-4.79,1a10.4,10.4,0,0,1-2.09-4s-.88,6.72,2.36,10.84,9.63,3.25,12.88.87S215.17,165.31,215.17,165.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.17,165.31l-.82-.65s0,3.75-1.29,4.61c0,0-4.1-.16-5.57,0A4.33,4.33,0,0,0,205,171s-3.06-1.14-4.79,1a10.4,10.4,0,0,1-2.09-4s-.88,6.72,2.36,10.84,9.63,3.25,12.88.87S215.17,165.31,215.17,165.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.66,173.11a20.3,20.3,0,0,1,1.67,2.5c.17-.06.34-.11.5-.18,2.25-.86,3-2,3.17-3a3.28,3.28,0,0,0-.15-1.47,2.77,2.77,0,0,0-.37-.75,11.31,11.31,0,0,1-4.06,2.6C205,173,204.66,173.11,204.66,173.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.42,172.8l.51.73c2.12-.82,3.5-1.68,3.92-2.58a2.77,2.77,0,0,0-.37-.75A11.31,11.31,0,0,1,205.42,172.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.83,175.43c2.25-.86,3-2,3.17-3a7.56,7.56,0,0,0-2.31,1.45A2.89,2.89,0,0,0,206.83,175.43Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78,153.94a6.77,6.77,0,0,0-3.89-3.93c-2.9-1-9.06-.53-11.81,1a46.85,46.85,0,0,1-5.53,2.55,15.24,15.24,0,0,1,4.18,1.69c2,1.23,7,.38,7,.38s-2,.52-2.05,1.12a1.16,1.16,0,0,1-1.5,1c-.69-.33.38,1.18,1.5.72s.12-1.71,1.5-1.19,2.46,1.85,3.84.4,1.86.07,4.36-1S216.78,153.94,216.78,153.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.24 150.36 164.47 146.92 164.47 149.5 156.24 153.07 156.24 150.36",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.24 150.36 164.47 146.92 164.47 149.5 156.24 153.07 156.24 150.36",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 287.03,
    y: 98.65,
    width: 5.54,
    height: 289.63,
    transform: "translate(-13.31 16.79) rotate(-3.24)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 287.03,
    y: 98.65,
    width: 5.54,
    height: 289.63,
    transform: "translate(-13.31 16.79) rotate(-3.24)",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.56,366.19l14.57,47.07H351.84s24.13-25.71,33.23-56.17C385.07,357.09,208.35,370.93,112.56,366.19Z",
    style: {
      fill: "#FFA47A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.07,357.09a110.15,110.15,0,0,1-4.71,12.7c-.16.37-.32.74-.49,1.11-1.49,3.31-3.1,6.51-4.78,9.57-.2.38-.41.75-.62,1.12-1.9,3.41-3.86,6.64-5.81,9.64-.24.38-.49.75-.73,1.12-2.15,3.26-4.25,6.22-6.2,8.83l-.82,1.09c-5.21,6.88-9.07,11-9.07,11H127.13l-2.48-8-.31-1-2.41-7.79-.32-1-2.45-7.91-.31-1-2.44-7.88-.32-1-3.53-11.41C208.35,370.93,385.07,357.09,385.07,357.09Z",
    style: {
      fill: "#FFA47A",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380.36,369.79c-.16.37-.32.74-.49,1.11-35.86,6.37-89.53,9.56-160.27,9.56q-43.87,0-96.45-1.64c-2.7-.09-5-.16-6.74-.2l-.32-1,7.09.22C243.42,381.58,329.85,378.88,380.36,369.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M375.09,380.47c-.2.38-.41.75-.62,1.12-34,5.44-82.65,8.17-145.3,8.17q-47.58,0-105.9-2.1l-4.11-.14-.31-1,4.46.16C239.43,390.86,324,388.77,375.09,380.47Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M368.66,391.23c-.24.38-.49.75-.73,1.12-31.94,4.5-75.44,6.76-130.12,6.76q-50.82,0-114.41-2.6l-1.47-.06-.32-1,1.83.08C234.77,400.07,317.06,398.62,368.66,391.23Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361.73,401.18l-.82,1.09c-32.1,3.34-74.21,5-126,5q-49.33,0-110.27-2l-.31-1C229.63,407.77,309.25,406.73,361.73,401.18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M381,359.07s-4,20.62-31.91,54.19h4.22s21.63-19.91,31.78-54.19Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.61,364.6s-2.9,26.63-11.86,48.66h-4.22s6.06-13.05,10.81-48.66Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.09 366.36 130.16 413.4 125.95 413.4 111.56 366.19 116.09 366.36",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31,366.94s2.41,25.09,8.47,46.32h4.75s-5.8-16.29-9.23-46.32Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381,359.07s-4,20.62-31.91,54.19h4.22s21.63-19.91,31.78-54.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.61,364.6s-2.9,26.63-11.86,48.66h-4.22s6.06-13.05,10.81-48.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.09 366.36 130.16 413.4 125.95 413.4 111.56 366.19 116.09 366.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31,366.94s2.41,25.09,8.47,46.32h4.75s-5.8-16.29-9.23-46.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.25,360.53s176,8.21,283-7.7l-2,8.26s-144.19,17.76-278,8.26Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.48,136.45a.48.48,0,0,1-.26-.07L280.48,133a.5.5,0,0,1-.17-.69.49.49,0,0,1,.68-.17l5.74,3.44a.49.49,0,0,1-.25.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,136.93a.52.52,0,0,1-.41-.21.5.5,0,0,1,.12-.7l5.52-3.94a.49.49,0,0,1,.69.12.51.51,0,0,1-.11.7l-5.52,3.93A.46.46,0,0,1,281,136.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,277.66a.41.41,0,0,1-.21-.05l-6.25-2.93a.5.5,0,1,1,.42-.9l6.25,2.93a.5.5,0,0,1-.21,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,278.18a.48.48,0,0,1-.41-.21.5.5,0,0,1,.12-.7l5.33-3.72a.5.5,0,0,1,.7.12.51.51,0,0,1-.12.7l-5.34,3.72A.49.49,0,0,1,289,278.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--water-1--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.94,416.24H426.6L402,415.35a5.75,5.75,0,0,0-3.91-2c-3.95-.64-16.14,1-17.76,0s.51-4.06-3.52-6.11-11.15,6.65-15.11,4.47S359,398.47,353,398.49s1.58,9.52-2.37,11.1-46.86-4.66-69.12-8.13-11.19-1.25-10.4,4.63-19.38,1.1-49.84-1.85-35.61,6.14-43.52,6.94-21.07-8.18-31.7-6.27-5.49,4.68-11.82,5.08-20.9-10.32-21.69-5.75,5.94,3.77,3.53,6.54-15.35-1.2-19.81-.79-4,3.27-4,3.27-12.87-1.71-11.87,3H55.61c.79,3.48,2,2.06,34.66,3.24s16,3.88,20.2,8.08,44.47-1.7,62.64,0,1.18,4.58,11.42,7.75,56.23,0,67.77,1.18-2.44,4.75,33.56,5.15,20.41-1.49,26.33-4.35c8.17-4,26.28-3.17,31.94-4.36s2.64-5.37,14.91-5.37,56.57.63,61.72,0,1.58-7.29,18-7.37S450.94,416.24,450.94,416.24Z",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.94,416.24H426.6L402,415.35a5.75,5.75,0,0,0-3.91-2c-3.95-.64-16.14,1-17.76,0s.51-4.06-3.52-6.11-11.15,6.65-15.11,4.47S359,398.47,353,398.49s1.58,9.52-2.37,11.1-46.86-4.66-69.12-8.13-11.19-1.25-10.4,4.63-19.38,1.1-49.84-1.85-35.61,6.14-43.52,6.94-21.07-8.18-31.7-6.27-5.49,4.68-11.82,5.08-20.9-10.32-21.69-5.75,5.94,3.77,3.53,6.54-15.35-1.2-19.81-.79-4,3.27-4,3.27-12.87-1.71-11.87,3H55.61c.79,3.48,2,2.06,34.66,3.24s16,3.88,20.2,8.08,44.47-1.7,62.64,0,1.18,4.58,11.42,7.75,56.23,0,67.77,1.18-2.44,4.75,33.56,5.15,20.41-1.49,26.33-4.35c8.17-4,26.28-3.17,31.94-4.36s2.64-5.37,14.91-5.37,56.57.63,61.72,0,1.58-7.29,18-7.37S450.94,416.24,450.94,416.24Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.18,417.9c-1.61-2.3-11.34,2.37-13.72,0s1.13-9.8-8.8-4.5-9.39,4.91-11.9,1.67-5.94-2.3-3.83,0-8.7,3.24-17.93,0-33-4.93-28,0-9,.82-13.18,1.17-.4,3.14-4.29,3.85-31.69,1.47-29.21,1.77c4.49.52,140.05,0,140.05,0s-2.38-1.16-8.18-1.77C392.23,420.09,393,420.54,391.18,417.9Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.53,431.35c-.73,1.22,51.62,0,54.68.79s8.06,2.38,13.6,1.59,26.38.95,29.54.21-1.58-5.42-4.22-6.38-1.52,3.29-1.52,3.29-4.81.31-10.87-3.29-9.23.1-7.92,1.95-6.85,4.06-11.34.58-7.27,0-7.27,0S207.11,428.71,205.53,431.35Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.23,416.81c-5.25-3.55-22.15-7.88-38-7.35s-10.82,6.17-13.58,6.78S187,418.43,176,415s-11.87-1.12-11.87,1.81-9.23.09-11.61.33.27,3.3-2.63,2.95-16.62-1.71-16.88,0h78.61s-2.39-4.75,3.41-3.88,6.33,1.22,6.59-1.46,8.71-1.54,13.72,0a13,13,0,0,1,7.16,5.31s-.42-3.28,2.67-3.28,1.83,3.31,1.83,3.31S250.78,418.54,248.23,416.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingsoonImg);
export default __webpack_public_path__ + "static/media/comingsoon-img.4942412de81f8d80fde0ba0cc6945cdf.svg";
export { ForwardRef as ReactComponent };